<div class="qty-on-estimate-dialog">
  <div class="qty-on-estimate-list-wrapper text-left">
    <div class="qty-on-estimate-list-header">
      <div class="qty-on-estimate-list-top">
        <h4 [id]="itemId">Quantity on Estimates Detail</h4>
        <i class="font-18 far fa-times font-gray-55 pointer p-1" data-dismiss="modal" (click)="handleClose()"
          aria-label="Close"></i>
      </div>
    </div>
    <div class="qty-on-estimate-list-body-content">
      <div class="row">
        <div class="col-12">
          <div class="qty-on-estimate-list-box-wrapper">
            <div class="qty-on-estimate-list-box">
              <div class="box-icon align-self-center d-none">
                <i class="fal fa-calendar-alt"></i>
              </div>
              <div *ngIf="!isLoading">
                <span *ngIf="stockList.length > 0" class="qty-item-name">
                  All estimates containing {{ itemName }} are listed below
                </span>
                <span *ngIf="stockList.length === 0" class="qty-item-name">
                  {{ itemName || 'Item' }} is currently not added to any estimate
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Sales trend -->
    <div class="ordering-table-wrapper py-0" *ngIf="!isLoading && stockList.length > 0">
      <div class="ordering-table-body mt-2">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" *ngFor="let columns of salesCol" [ngClass]="columns.className">
                <div>
                  {{ columns.header }}
                </div>
              </th>
            </tr>
          </thead>
          <tbody #salesContainer>
            <tr *ngFor="let item of stockList">
              <td class="sup-date text-left">{{ item?.creationDate }}</td>
              <td class="quantity">{{ item?.quantity }}</td>
              <td class="roNumber pointer hover-underline text-underline" (click)="openRO(item)">{{ item?.code }}</td>
              <td class="price">{{ item?.price }}</td>
              <td class="cost">{{ item?.cost }}</td>
              <td class="core">{{ item?.coreCost }}</td>
            </tr>
          </tbody>
        </table>
        <p-paginator class="ui-g-12 p-0" [rows]="tableConfig.limit" [totalRecords]="totalRecords"
          (onPageChange)="paginate($event)">
        </p-paginator>
      </div>
    </div>

    <!-- Loading spinner -->
    <div *ngIf="isLoading" class="loading-estimate">
      <i class="fal fa-spinner rotate ml-2"></i>
    </div>
  </div>
</div>